import React from 'react';
import { Media } from 'reactstrap';
import './MediaItem.scss';

const MediaItem = ({ media, heading, description }) => (
  <Media className="media-item">
    <Media left>
      <Media className="media-item__media-container">{media}</Media>
    </Media>
    <Media body className="media-item__body">
      <Media heading className="media-item__heading">
        {heading}
      </Media>
      <span className="media-item__description">{description}</span>
    </Media>
  </Media>
);

export default MediaItem;
